import parseDateForLocal from './parseDateForLocal'

export default function (date) {
  date = parseDateForLocal(date)
  if(!date) return

  let day = date.getDate()
  if(isNaN(day)) return

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${hours}:${minutes}`
}
